var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "lottieBox",
    style: {
      'top': _vm.clientY
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.apngSrc
    }
  })]);
};
var staticRenderFns = [];
export { render, staticRenderFns };